export default Object.freeze({
  RejectProcessInstance: 'reject-process-instance',
  CancelProcessInstance: 'cancel-process-instance',
  ExecuteAction: 'execute-action',
});
